import React from 'react';
import clsx from 'clsx';
import { Route, Switch, useLocation, useRouteMatch, Redirect } from 'react-router-dom';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

import { SectionHeading } from './SectionActions';

export default function PageEditView({ tabs, isOnDesignTab }) {
  const match = useRouteMatch();
  const location = useLocation();
  const { isAuthenticating } = useAuth();

  const defaultPath = tabs[0]?.path;

  return (
    <div className={clsx('px-4 pt-3 md:px-6', { 'pb-16': !isOnDesignTab })}>
      <div className="outline-none">
        <Switch>
          {tabs.map((tab, index) => (
            <Route exact path={`${match.url}${tab.path}`} key={index}>
              <PageEditViewPanel tab={tab} />
            </Route>
          ))}

          {/* Tabs gated on the seller (its custom domain) are missing until auth loads it,
              and the page can render first; redirecting then loses a deep link. */}
          {!isAuthenticating && (
            <Redirect
              from={match.path}
              to={{ pathname: `${match.path}${defaultPath}`, search: location.search }}
            />
          )}
        </Switch>
      </div>
    </div>
  );
}

export function PageEditViewPanel({ tab }) {
  return (
    <div
      className={clsx({
        'max-w-lg': tab.width === 'lg',
        'max-w-xl': tab.width === 'xl',
        'max-w-2xl': tab.width === '2xl',
        'max-w-3xl': tab.width === '3xl',
        'max-w-4xl': tab.width === '4xl',
      })}
    >
      {!tab.hideHeader && (
        <>
          <SectionHeading section={tab} />

          {tab.description && (
            <div className="mb-4 text-gray-500 dark:text-muted-foreground text-sm">
              {tab.description}
            </div>
          )}
        </>
      )}

      {tab.component}
    </div>
  );
}
